import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { UNIFIED_PROJECT_STEPS } from "containers/UnifiedProject/reducer";

import HeaderTab from "components/UnifiedProject/HeaderTab";

import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as runReducer from "containers/Run/reducer";

class HeaderTabContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  /*
  shouldComponentUpdate(nextProps, nextState) {
    const {
      stepId,
      disabled,
      isComplete,
      showCheck,
      active,
      currentStep,
      isLoading,
    } = this.props;

    const shouldUpdate =
      stepId !== nextProps.stepId ||
      disabled !== nextProps.disabled ||
      isComplete !== nextProps.isComplete ||
      showCheck !== nextProps.showCheck ||
      active !== nextProps.active ||
      isLoading !== nextProps.isLoading ||
      (currentStep !== nextProps.currentStep &&
        (currentStep === stepId || nextProps.currentStep === stepId));

    return shouldUpdate;
  }
  */

  handleClick(e) {
    const { selectStep, disabled, onClick } = this.props;
    if (disabled) {
      return;
    }
    onClick && onClick();
    return selectStep();
  }

  render() {
    const {} = this.props;

    return <HeaderTab {...this.props} onClick={(e) => this.handleClick(e)} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    selectStep: () => dispatch(unifiedProjectReducer.selectStep(ownProps.id, ownProps.stepId))
  };
};

const mapStateToProps = (state, ownProps) => {
  const hStep = UNIFIED_PROJECT_STEPS[ownProps.stepId];
  const currentStep = unifiedProjectReducer.getCurrentStep(state, ownProps.id);
  const selectedRunId = ownProps.id === "new" ? "new" : projectReducer.getRunId(state, ownProps.id);
  const setup = setupReducer.getSetup(state, selectedRunId);

  return {
    active: hStep && currentStep === hStep.id,
    showCheck: hStep && hStep.showCheck,
    disabled:
      hStep && typeof hStep.disabled === "function" ? hStep.disabled(state, ownProps.id) : hStep && hStep.disabled,
    label: hStep && hStep.label,
    completeLabel:
      hStep && typeof hStep.completeLabel === "function"
        ? hStep.completeLabel(state, ownProps.id)
        : hStep && hStep.completeLabel,
    title: hStep && typeof hStep.title === "function" ? hStep.title(state, ownProps.id) : hStep && hStep.title,
    showWarn:
      hStep && typeof hStep.showWarn === "function" ? hStep.showWarn(state, ownProps.id) : hStep && hStep.showWarn,
    hidden: hStep && typeof hStep.hidden === "function" ? hStep.hidden(state, ownProps.id) : hStep && hStep.hidden,

    isComplete: runReducer.getHasModels(state, selectedRunId),
    isLoading: setup === undefined || Object.keys(setup).length === 0,

    isEditBlueprint: unifiedProjectReducer.getIsEditBlueprint(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(HeaderTabContainer);
